export const handleOnClick=(e,onClick,args)=>{e?.stopPropagation(),e?.preventDefault(),onClick?.(args)};